module.exports = __webpack_public_path__ + "3d762564b2be000f52ca9038e8f42ad4.svg";